<template>
  <div class="swiperMobile">
    <div class="swiperHand">
      <img src="../assets/imgs/hand.svg" alt="">
    </div>
    <div class="swiperContent">
      <img src="../assets/imgs/arrow_hand.svg" alt="">
      <span>Deslize para navegar na tabela</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwipperMobile',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swiperMobile {
  width: 100%;
  justify-content: flex-end;
  display:none;
  margin: 10px 0 0 0;
}
.swiperHand {
  margin:20px 10px 0 0;
}
.swiperContent {
  font-size: 10px;
  color: #D9D9D8;
  max-width: 90px;
} 
.swiperContent img {
  margin: 0 0 0 -20px;
}

.swiperContent span {
  display: block;
}

.swiperHand {
  animation: handmove 2s infinite;
}

@keyframes handmove {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(40deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@media screen and (max-width: 500px) {
  .swiperMobile {
    display: flex;
  }
}

</style>
